import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { AddButton, Flex, InputWrapper, LevelLabel } from "./style";
import { Box } from "../../assets/globalStyles/styledColoredBoxWithInfo";
import SwitchButton from "../../components/switchButton";
import SelectOption from "../../components/selectOption";
import {
  getTypeObject,
  getTypeObjects,
  LEVELS,
  MAX_LEVEL,
  TYPES
} from "../../constants/accounting";
import { Field } from "redux-form";
import TextField from "../../components/textField";
import returnNumber from "../../lib/returnNumber";
import { Confirm } from "../../components/confirm";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../constants/otherTexts";
import { StyledIcon } from "../../assets/globalStyles/styledIcon";
import { accountingCodeLength } from "../../constants/maxLenghtAtrribute";

const AccountingCode = props => {
  const [expand, setExpand] = useState(false);
  const [confirm, setConfirm] = useState({ show: false, message: "" });

  const {
    disabled,
    fields,
    formErrors,
    updateErrors,
    change,
    title,
    template,
    isTemplate,
    hasConstantCode,
    mainFieldType,
    isMultiLevel,
    infoText
  } = props;
  const levels = LEVELS();

  useEffect(() => {
    if (fields.length > 0) {
      setExpand(true);
    } else {
      setExpand(false);
    }
  }, [fields]);
  const toggleSwitch = () => {
    if (fields.length <= 0) {
      if (!hasConstantCode && template && template.length > 0) {
        template.forEach(item => {
          fields.push(item);
        });
      } else {
        const initializeData = hasConstantCode ? { type: TYPES.CONSTANT } : {};
        fields.push(initializeData);
      }
    }
    if (expand) {
      fields.removeAll();
    }
    setExpand(!expand);
  };

  const removeRow = index => {
    if (fields.length <= 1 && index === 0) {
      setExpand(false);
    }
    fields.remove(index);
    changeError(index, true);
  };

  const changeError = (index, remove) => {
    const copyErrors = [...formErrors];
    let newErrors;
    if (remove) {
      newErrors = copyErrors.filter((error, i) => i !== index);
    } else {
      newErrors = copyErrors.map((error, i) => {
        if (index === i) {
          return "";
        } else {
          return error;
        }
      });
    }
    updateErrors(newErrors);
  };

  const renderRow = (row, index) => {
    if (hasConstantCode) {
      return (
        <Flex align="start" marginBottom="3.6" key={index} marginTop="2">
          <div className="text-input-wrapper">
            <Field
              component={TextField}
              name={`${row}.code`}
              inputMode="decimal"
              label="کد حسابداری"
              meta={{
                error: formErrors[index] ? formErrors[index].code : ""
              }}
              normalize={number => returnNumber(number)}
              onChange={value => {
                changeError(index);
                change(value, index, "code");
              }}
              maxLength={accountingCodeLength}
              alignLeft
            />
          </div>
        </Flex>
      );
    } else {
      return (
        <Flex align="start" marginBottom="3.6" key={index} marginTop="2">
          <LevelLabel>{levels[index + 1]}</LevelLabel>
          <InputWrapper maxWidth="360px">
            {mainFieldType === "text" && (
              <Field
                component={TextField}
                name={`${row}.code`}
                inputMode="decimal"
                label={levels[index + 1]}
                meta={{
                  error: formErrors[index]
                }}
                normalize={number => returnNumber(number)}
                onChange={value => {
                  changeError(index);
                  change(value, index, "code");
                }}
                maxLength={accountingCodeLength}
                alignLeft
              />
            )}
            <div className="row-inputs">
              {mainFieldType === "select" && (
                <Field
                  component={SelectOption}
                  name={row}
                  label="نوع کد"
                  options={normalizer(getTypeObjects(isMultiLevel))}
                  meta={{ error: formErrors[index] }}
                  onChange={value => {
                    changeError(index);
                    change(value, index);
                  }}
                />
              )}

              {mainFieldType === "select" &&
                !isTemplate &&
                parseInt(fields.get(index).type) === TYPES.CONSTANT && (
                  <div className="text-input-wrapper">
                    <Field
                      component={TextField}
                      name={`${row}.code`}
                      inputMode="decimal"
                      label={levels[index + 1]}
                      meta={{
                        error: formErrors[index] ? formErrors[index].code : ""
                      }}
                      normalize={number => returnNumber(number)}
                      onChange={value => {
                        changeError(index);
                        change(value, index, "code");
                      }}
                      maxLength={accountingCodeLength}
                      alignLeft
                    />
                  </div>
                )}
            </div>
          </InputWrapper>
          {!disabled && (
            <StyledIcon
              onClick={() => removeRow(index)}
              title="حذف"
              fontSize={18}
              mr={8}
            >
              <i className="icon mapsa-delete" />
            </StyledIcon>
          )}
        </Flex>
      );
    }
  };
  const addLevel = () => {
    fields.push({});
  };
  const canAdd = () => {
    return !hasConstantCode && fields.length < MAX_LEVEL;
  };

  const closeConfirm = () => {
    setConfirm({ show: false, message: "" });
  };
  const showConfirm = infoMessage => {
    setConfirm({ show: true, message: infoMessage });
  };

  return (
    <React.Fragment>
      <Confirm
        show={confirm.show}
        rejectHandler={() => closeConfirm()}
        close={() => closeConfirm()}
        content={{
          type: "info",
          message: confirm.message,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT,
          icon: "icon mapsa-i-letter"
        }}
      />
      <Box>
        <Flex>
          <Flex>
            <span className="title">
              {title || "الگو کد حسابداری سرفصل‌حساب‌ها"}
            </span>
            <StyledIcon
              onClick={() => showConfirm(infoText)}
              mr={8}
              fontSize={22}
            >
              <i className="icon mapsa-info" />
            </StyledIcon>
          </Flex>
          <div className="switch-wrapper">
            <SwitchButton
              input={{ value: expand, onChange: toggleSwitch }}
              disable={disabled}
            />
          </div>
        </Flex>
        {expand && (
          <React.Fragment>
            {fields.map((item, index) => renderRow(item, index))}
            {canAdd() && !disabled && (
              <Flex marginTop="2">
                <AddButton onClick={addLevel}>
                  <i className="icon mapsa-plus" />
                  <span>افزودن سطح بیشتر</span>
                </AddButton>
              </Flex>
            )}
          </React.Fragment>
        )}
      </Box>
    </React.Fragment>
  );
};

const normalizer = data => {
  if (Array.isArray(data)) {
    return data.map(obj => {
      return { ...obj, value: obj.value, key: obj.type };
    });
  } else {
    //object
    const typeObj = getTypeObject(data.type);
    const value = typeObj ? typeObj.value : "";
    return { ...data, value: value, key: data.type };
  }
};
export default withRouter(AccountingCode);
